var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('section',{staticClass:"panda-container"},[_c('section',{staticClass:"panda-sidebar is-menu-spread"},[_c('NavMenu')],1)]),_vm._v(" "),_c('section',{staticClass:"panda-body is-body-spread"},[_c('Header',{attrs:{"username":_vm.username}}),_vm._v(" "),_c('div',{staticClass:"panda-content"},[_c('router-view')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ff7cc4d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home.vue
// module id = null
// module chunks = 